import { render, staticRenderFns } from "./goout.vue?vue&type=template&id=49f35672&scoped=true"
import script from "./goout.vue?vue&type=script&lang=js"
export * from "./goout.vue?vue&type=script&lang=js"
import style0 from "./goout.vue?vue&type=style&index=0&id=49f35672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f35672",
  null
  
)

export default component.exports